import { Flex } from '@mantine/core';

type PlayerCardEmptyProps = {
  label: JSX.Element;
};

export function PlayerCardEmpty({ label }: PlayerCardEmptyProps) {
  return (
    <Flex align="center" mih={84} /* eslint-disable-line local-rules/use-theme-tokens */ gap={4} justify="center">
      {label}
    </Flex>
  );
}
